import { Payment } from '@apply/api/src/api/PaymentApi';
import { PaymentStatus } from '@apply/constants';
import { formatCurrency } from '@apply/ui';

interface PaymentDetailsSectionParameters {
    payment: Payment;
}

export const PaymentDetailsSection: React.FC<PaymentDetailsSectionParameters> = ({ payment }) => {
    const calculateStatus = (status: PaymentStatus): string => {
        switch (status) {
            case PaymentStatus.Failure:
                return 'Failure';
            case PaymentStatus.InProgress:
                return 'In Progress';
            case PaymentStatus.Refund:
                return 'Refund';
            case PaymentStatus.Success:
                return 'Success';
        }
    };

    return (
        <>
            <div className='payment-edit-section'>Payment Details</div>
            <table>
                <tr>
                    <td className='payment-edit-details-label'>Amount</td>
                    <td className='payment-edit-details-value'>{formatCurrency(payment.amount)}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Fee</td>
                    <td className='payment-edit-details-value'>{formatCurrency(payment.amount * 0.025)}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Net</td>
                    <td className='payment-edit-details-value'>{formatCurrency(payment.amount * 0.975)}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Status</td>
                    <td className='payment-edit-details-value'>{calculateStatus(payment.paymentStatus)}</td>
                </tr>
                <tr>
                    <td className='payment-edit-details-label'>Description</td>
                    <td className='payment-edit-details-value'>{payment.memo}</td>
                </tr>
            </table>
        </>
    );
};
